import {useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';

import FieldWrapper from '../form/field-wrapper';
import FormControl from '../form/form-control';
import Input from '../form/input';
import {AllocationFormSchemaErrors, AllocationFormSchemaType} from './allocation-form-schema';

export const AllocationNameField = () => {
  const {t} = useTranslation('common', {keyPrefix: 'components.advisor-predetermined-allocation-form'});
  const {values, touched, errors, handleChange, handleBlur} = useFormikContext<AllocationFormSchemaType>();

  return (
    <FormControl
      isRequired={true}
      isInError={!!errors.name && touched.name}
      errors={touched.name && errors.name ? [t(errors.name as AllocationFormSchemaErrors)] : []}
    >
      <FieldWrapper label={t('label-name')} identifier="name">
        <Input
          data-testid="allocation-name-input"
          name="allocation-name"
          value={values.name}
          onChange={handleChange('name')}
          onBlur={handleBlur('name')}
        />
      </FieldWrapper>
    </FormControl>
  );
};
